// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2a4MT","content":"GlobalSearch_content__25RN7"};